import { css } from '@emotion/css'
import TextField from '@mui/material/TextField'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'
import { getStyles } from '../../../../utils/utils/commonUtils'
import inputFieldStyles from '../styles/inputFieldStyles'

function TextInputField({
  styles,
  propName,
  api,
  disabled,
  maxLength,
  onChange,
  onlyNumbers,
  onlyNumbersAndLetters,
  ...props
}) {
  const classes = getStyles(inputFieldStyles)
  const { value } = props

  const handleOnChange = (e) => {
    if (onlyNumbers) {
      onOnlyNumbersChange(e, onChange)
    } else if (onlyNumbersAndLetters) {
      onOnlyLettersAndNumbersChange(e, onChange)
    } else {
      onChange(e)
    }
  }

  return (
    <TextField
      variant={'outlined'}
      autoFocus={!!props.autoFocus}
      className={classNames(
        classes.textField({ styles, ...props }),
        props.fullWidth && css(classes.fullWidth)
      )}
      value={value}
      sx={styles}
      disabled={disabled}
      inputProps={{
        maxLength,
      }}
      onChange={handleOnChange}
      {...props}
    />
  )
}

const onOnlyNumbersChange = (e, onChange) => {
  e.target.value = e?.target?.value.replace(/\D/g, '')

  onChange(e)
}

const onOnlyLettersAndNumbersChange = (e, onChange) => {
  e.target.value = e?.target?.value.replace(/[^a-zA-Zа-яА-Я0-9]/g, '')

  onChange(e)
}

export default observer(TextInputField)
